import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import Grid from "@mui/material/Grid"
import TextField from "@mui/material/TextField"
import Save from "@mui/icons-material/Save"
import DeleteIcon from "@mui/icons-material/Delete"

import ResetIcon from "@mui/icons-material/Refresh"

import { TradingPair } from "../../../interface/TradingPair"
import { useState } from "react"
import { User } from "../../../interface/User"
import CircularProgress from "@mui/material/CircularProgress"
import FormControlLabel from "@mui/material/FormControlLabel"
import Switch from "@mui/material/Switch"
import IconButton from "@mui/material/IconButton"
import { ConfirmModal } from "../Confirm/ConfirmModal"
import Box from "@mui/material/Box"

interface MultiPairEditModalProps
{
  open: boolean
  tradingPair: TradingPair
  userDetails: User
  onClose: () => void
  updateUserSettings: (user: Partial<User>) => Promise<void>
}
export const MultiPairEditModal = ({ open, userDetails, onClose, tradingPair, updateUserSettings }: MultiPairEditModalProps) =>
{
  const [ currentTradingPair, setPair ] = useState(tradingPair.pair)
  const [ maxInvest, setMaxInvest ] = useState(tradingPair.maxInvest)
  const [ currentInvest, setCurrentInvest ] = useState(tradingPair.currentInvest)
  const [ interval, setInterval ] = useState(tradingPair.interval)
  const [ isStopLossEnabled, setStopEnabled ] = useState(tradingPair.isStopLossEnabled)
  const [ useDynamicStop, setDynamicStop ] = useState(tradingPair.useDynamicStop)
  const [ stopLossPercentage, setStopPercent ] = useState(tradingPair.stopLossPercentage)
  const [ showConfirmDelete, setShowConfirmDelete ] = useState(false)
  const [ isMinSellProfitEnabled, setIsMinSellProfitEnabled ] = useState(true)
  const [ takeProfitThreshold, setTakeProfitThreshold ] = useState(0.2)
  const [ enableLong, setEnableLong ] = useState(true)

  const [ saving, setSaving ] = useState(false)

  const onSave = async () => {

    setSaving(true)

    const updatedPairs = userDetails?.tradingPairs?.map(pair => {
      if(pair._id === tradingPair._id)
      {
        return (
          { ...pair, 
            maxInvest, 
            pair: currentTradingPair,
            currentInvest,
            useDynamicStop,
            isStopLossEnabled, 
            stopLossPercentage, 
            interval,
            isMinSellProfitEnabled,
            takeProfitThreshold,
            enableLong
          }
        )
      }
      
      return pair
    })

    await updateUserSettings({ tradingPairs: updatedPairs })
    setSaving(false)

  }

  const handleDelete = async () => {
    setSaving(true)
    const updatedPairs = userDetails?.tradingPairs?.filter(pair => pair._id !== tradingPair._id)
    await updateUserSettings({ tradingPairs: updatedPairs })
    onClose()
    setSaving(false)

  }

  return (<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle>Edit Pair</DialogTitle>
    <DialogContent>
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <TextField fullWidth placeholder="Pair" value={currentTradingPair} onChange={(e: any) => setPair(e.target.value)}></TextField>
        </Grid>

        <Grid item>
          <TextField label="Max Investment" InputProps={{ startAdornment: "$" }} fullWidth placeholder="Max Invest" value={maxInvest} onChange={(e: any) => setMaxInvest(e.target.value)}></TextField>
        </Grid>

        <Grid item>
          <TextField 
            label="Current Investment" 
            InputProps={{ startAdornment: "$", endAdornment: <IconButton onClick={() => setCurrentInvest(0)}><ResetIcon /></IconButton> }} 
            fullWidth 
            placeholder="Current Investment" 
            value={currentInvest} 
            onChange={(e: any) => setCurrentInvest(e.target.value)}></TextField>
        </Grid>

        <Grid item>
          <TextField label="Chart Interval" fullWidth placeholder="Chart Interval" value={interval} onChange={(e: any) => setInterval(e.target.value)}></TextField>
        </Grid>

        <Grid item>
          <FormControlLabel label="Enable Stop Loss" control={<Switch checked={isStopLossEnabled} onChange={(_, checked) => setStopEnabled(checked)} />} ></FormControlLabel>
        </Grid>

        <Grid item>
          <FormControlLabel label="Enable Dynamic Stop" control={<Switch checked={useDynamicStop} onChange={(_, checked) => setDynamicStop(checked)} />} ></FormControlLabel>
        </Grid>

        { isStopLossEnabled && <Grid item>
          <TextField label="Stop Loss Percentage (Calculated automatically when dynamic is enabled)" InputProps={{ endAdornment: "%" }} disabled={useDynamicStop} fullWidth placeholder="Stop Loss Percentage" value={stopLossPercentage} onChange={(e: any) => setStopPercent(e.target.value)}></TextField>
        </Grid> }

        <Grid item>
          <FormControlLabel label="Enable Long" control={<Switch checked={enableLong} onChange={(_, checked) => setEnableLong(checked)} />} ></FormControlLabel>
        </Grid>

         <Grid item>
          <FormControlLabel label="Min Sell Threshold" control={<Switch checked={isMinSellProfitEnabled} onChange={(_, checked) => setIsMinSellProfitEnabled(checked)} />} ></FormControlLabel>
        </Grid> 

        <Grid item>
          <TextField label="Min sell threshold" InputProps={{ endAdornment: "%" }} disabled={!isMinSellProfitEnabled} fullWidth placeholder="Min sell threshold" value={takeProfitThreshold} onChange={(e: any) => setTakeProfitThreshold(e.target.value)}></TextField>
        </Grid> 

      </Grid>
    </DialogContent>

    <DialogActions>
      <Button onClick={onClose}>Close</Button>
      <Box flex={1} />
      <Button color="secondary" startIcon={<DeleteIcon />} onClick={() => setShowConfirmDelete(true)}>Delete</Button>
      <Button disabled={saving} onClick={onSave} startIcon={saving ? <CircularProgress size={16} /> : <Save />}>Save</Button>
    </DialogActions>

    { showConfirmDelete && <ConfirmModal id="" open onConfirm={handleDelete} title="Confirm Delete Pair" description="Do you want to delete this user pair?" handleClose={() => setShowConfirmDelete(false) } /> }
  </Dialog>)
}